export const CLEAR_CACHE_HEADER = 'clear-cache';

export interface CacheOptions {
  urlsToCache: string[];
  ttls?: { [url: string]: number };
  globalTTL?: number;
}
